import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { itemService } from '../services/api';
import { db } from '../db'; 

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await itemService.login({ email, password });
            const data = await response.json();

            if (response.ok) {
                const hId = data.user.household_id;

                // 1. LocalStorage pour un accès rapide
                localStorage.setItem('token', data.token);
                localStorage.setItem('household_id', hId);
                localStorage.setItem('user_name', data.user.name);

                // 2. Mise à jour Dexie (sans boucle infinie)
                await db.user.clear();
                await db.user.add({
                    id: data.user.id,
                    name: data.user.name,
                    token: data.token,
                    household_id: hId
                });

                navigate('/');
                window.location.reload(); // Force un rafraîchissement propre
            } else {
                setError(data.message || "Identifiants incorrects");
            }
        } catch (err) {
            setError("Erreur de connexion au serveur");
        }
    };

    return (
        <Container className="py-5">
            <Card className="shadow-sm border-0 rounded-4 mx-auto" style={{maxWidth: '400px'}}>
                <Card.Body className="p-4">
                    <h3 className="text-center fw-bold mb-4">Connexion</h3>
                    {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}
                    <Form onSubmit={handleLogin}>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Email</Form.Label>
                            <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="small fw-bold">Mot de passe</Form.Label>
                            <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        </Form.Group>
                        <Button variant="success" type="submit" className="w-100 rounded-pill fw-bold py-2 shadow-sm">
                            Se connecter
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Login;